import { render, staticRenderFns } from "./aShopDetailCategory.vue?vue&type=template&id=58b572f6&scoped=true"
import script from "./aShopDetailCategory.vue?vue&type=script&lang=js"
export * from "./aShopDetailCategory.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailCategory.vue?vue&type=style&index=0&id=58b572f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b572f6",
  null
  
)

export default component.exports